import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import MessageIcon from '@material-ui/icons/Message';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

interface OwnProps {
  selected: string[],
  fundraisingId?: number,
}

const EditAmbassadorMessageButton = (props: ButtonProps & OwnProps) => {
  const { disabled, selected, fundraisingId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOnClick = () => {
    dispatch(openDialog({
      dialog: DIALOGS.editAmbassadorMessage,
      payload: {
        fundraisingId,
        selected,
      },
    }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.edit_ambassador_message')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOnClick}
            disabled={disabled || !selected.length || !fundraisingId}>
            <MessageIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default EditAmbassadorMessageButton;
